var $1609d77cb8ca2a52$exports = {};
let $1609d77cb8ca2a52$var$good = 0;
let $1609d77cb8ca2a52$var$neutral = 0;
let $1609d77cb8ca2a52$var$bad = 0;
const $1609d77cb8ca2a52$var$updateDiagram = ()=>{
    const total = $1609d77cb8ca2a52$var$good + $1609d77cb8ca2a52$var$neutral + $1609d77cb8ca2a52$var$bad;
    const goodPercentage = $1609d77cb8ca2a52$var$good / total * 100 || 0;
    const neutralPercentage = $1609d77cb8ca2a52$var$neutral / total * 100 || 0;
    const badPercentage = $1609d77cb8ca2a52$var$bad / total * 100 || 0;
    const diagramElement = document.getElementById("diagram");
    const diagramContainer = document.querySelector(".diagram-container");
    const noticeElement = document.querySelector(".notice");
    if (total > 0) {
        noticeElement.style.opacity = 0;
        noticeElement.style.display = "none";
        diagramContainer.classList.add("show");
    // setTimeout(() => {
    // }, 100);
    }
    diagramElement.style.setProperty("background", `conic-gradient(
            #3f8125 0% ${goodPercentage}%, 
            orange ${goodPercentage}% ${goodPercentage + neutralPercentage}%, 
            red ${goodPercentage + neutralPercentage}% ${goodPercentage + neutralPercentage + badPercentage}%, 
            transparent ${goodPercentage + neutralPercentage + badPercentage}% 100%)`);
    document.getElementById("total").textContent = total;
    document.getElementById("goodCount").textContent = $1609d77cb8ca2a52$var$good;
    document.getElementById("neutralCount").textContent = $1609d77cb8ca2a52$var$neutral;
    document.getElementById("badCount").textContent = $1609d77cb8ca2a52$var$bad;
    document.getElementById("totalCount").textContent = total;
    document.getElementById("positivePercentage").textContent = `${goodPercentage.toFixed(1)}%`;
    const percentageText = document.getElementById("percentageText");
    percentageText.textContent = `${goodPercentage.toFixed(1)}%`;
    const heartFill = document.getElementById("heartFill");
    heartFill.style.transform = `scaleY(${goodPercentage / 100})`;
};
document.querySelector(".feedback-buttons").addEventListener("click", (event)=>{
    const target = event.target.closest("button");
    if (!target) return;
    if (target.id === "likeButton") $1609d77cb8ca2a52$var$good++;
    else if (target.id === "neutralButton") $1609d77cb8ca2a52$var$neutral++;
    else if (target.id === "dislikeButton") $1609d77cb8ca2a52$var$bad++;
    $1609d77cb8ca2a52$var$updateDiagram();
});
$1609d77cb8ca2a52$var$updateDiagram();


//# sourceMappingURL=index.43bf1e6a.js.map
